module.exports = "../../../../platform/assets/pageMainIcon/cd-org-account-books.svg";